import React from 'react'
import {HotelDescriptions} from 'components/Accommodation/HotelDescriptions/HotelDescriptions'
import {PopularFacilities} from 'components/Accommodation/PopularFacilities'
import {useAccommodation} from 'hooks/useAccommodation'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import type {ContentHotel} from '@findhotel/sapi'

interface Props {
  hotel: ContentHotel
}

export const HotelPropertyInfo: React.FC<Props> = ({hotel}) => {
  const {hasPopularFacilitiesSection} = useAccommodation(hotel)
  const {isDesktopXs} = useDeviceLayout()

  return (
    <Box display="flex" flexDirection="column" gap="s700">
      <HotelDescriptions
        hotel={hotel}
        withTopDivider={false}
        descriptionPaddingBottom="s200"
        titlePaddingBottom="s300"
        descriptionLineClamp={isDesktopXs ? 4 : 2}
        title={
          <FormattedMessageWrapper
            id="aboutThisProperty"
            defaultMessage="About this property"
          />
        }
      />
      {hasPopularFacilitiesSection && (
        <PopularFacilities
          hotel={hotel}
          columns={isDesktopXs ? 1 : 2}
          hideTitle
          gap="s300"
          facilitiesRowGap="s300"
        />
      )}
    </Box>
  )
}
